// Copyright 2018-2024 the Deno authors. All rights reserved. MIT license.
// This module is browser compatible.

import { assertArg } from "../_common/from_file_url.ts";

/**
 * Converts a file URL to a path string.
 *
 * @example Usage
 * ```ts
 * import { fromFileUrl } from "@std/path/posix/from-file-url";
 * import { assertEquals } from "@std/assert";
 *
 * assertEquals(fromFileUrl(new URL("file:///home/foo")), "/home/foo");
 * ```
 *
 * @param url The file URL to convert.
 * @returns The path string.
 */
export function fromFileUrl(url: URL | string): string {
  url = assertArg(url);
  return decodeURIComponent(
    url.pathname.replace(/%(?![0-9A-Fa-f]{2})/g, "%25"),
  );
}

// denoCacheMetadata={"headers":{"age":"1048","server":"UploadServer","x-goog-metageneration":"1","x-guploader-uploadid":"AHmUCY1M9dqWnNqIY2bsF1DZwSMIrvyWI2JRwQARhi0UtUh50ORa2Tmm0MVkFXIyrMna5UW9AyPH1CBq9A","x-goog-generation":"1730457482833990","x-goog-stored-content-encoding":"identity","last-modified":"Fri, 01 Nov 2024 10:38:02 GMT","content-type":"text/typescript","x-robots-tag":"noindex","cache-control":"public, max-age=31536000, immutable","content-security-policy":"default-src 'none'; script-src 'none'; style-src 'none'; img-src 'none'; font-src 'none'; connect-src 'none'; frame-src 'none'; object-src 'none'; frame-ancestors 'none'; sandbox; form-action 'none';","x-jsr-cache-status":"hit","x-goog-hash":"crc32c=/E1OEQ==,md5=zsGMIHTa9QJrFca1eJHiTA==","date":"Fri, 08 Nov 2024 09:52:32 GMT","content-length":"689","accept-ranges":"bytes","expires":"Sat, 08 Nov 2025 09:52:32 GMT","etag":"\"cec18c2074daf5026b15c6b57891e24c\"","x-content-type-options":"nosniff","access-control-expose-headers":"*","x-goog-storage-class":"STANDARD","via":"1.1 google","x-jsr-cache-id":"IAD","cross-origin-resource-policy":"cross-origin","alt-svc":"h3=\":443\"; ma=2592000,h3-29=\":443\"; ma=2592000","x-goog-stored-content-length":"689","access-control-allow-origin":"*"},"url":"https://jsr.io/@std/path/1.0.8/posix/from_file_url.ts","time":1731060600}